import { notification } from 'antd';
import { useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { AlertState } from 'schemas';

const Alert = () => {
    const [api, contextHolder] = notification.useNotification();
    const alert = useRecoilValue(AlertState);
    const setAlert = useSetRecoilState(AlertState);

    useEffect(() => {
        if (alert?.msg) {
            const validTypes = ['success', 'error', 'info', 'warning'];
            const notificationType = validTypes.includes(alert.type) ? alert.type : 'info';
            
            api[notificationType]({
                message: alert.type.toUpperCase(),
                duration: 10,
                description: alert.msg,
                style: {
                    width: 450,
                },
            });
            
            // Clear alert after showing (important!)
            setTimeout(() => {
                setAlert({ type: '', msg: '' });
            }, 100);
        }
    }, [alert, api, setAlert]);

    return <>{contextHolder}</>;
};

export default Alert;